import template from './next-button.html';
import { selectors } from '../../../../state';
import {
  ITEM_KINDS,
  ITEM_DEFINITION_CODES,
  ITEM_STATUSES,
} from '../../../../constants';
import { getNextStepByOrder, getPriorityStep } from './next-button.utils';
import { trackNextClick } from '../../../steps/forward-mail/old-design/list/list.component';

class NextButtonController {
  constructor(updStore) {
    'ngInject';
    Object.assign(this, { updStore });
  }

  $onInit() {
    this.disconnect = this.updStore.connect(mapStateToThis)(this);
  }

  $onDestroy() {
    this.disconnect();
  }

  trackFymNextClick() {
    if (
      this.currentStepKind === ITEM_KINDS.FORWARD_MAIL &&
      this.nextStep.code === ITEM_DEFINITION_CODES.HOME_SERVICE_APP
    ) {
      trackNextClick();
    }
  }
}

export const NextButtonComponent = {
  template,
  controller: NextButtonController,
};

function mapStateToThis(state) {
  const { current, itemDefinitionPhase, itemDefinition, router } = selectors;

  const move = current.move(state);
  const items = current.items(state).map(mapItem(state));
  const phases = itemDefinitionPhase
    .all(state)
    .reduce(phaseMapReducer(state), {});
  const steps = itemDefinition
    .all(state)
    .map(mapItemDefinitions(phases, state))
    .filter(shouldIncludeStep(items, state));

  const currentStepKind = selectors.router.currentDataMoveItemType(state);

  return {
    currentStepKind,
    nextStep:
      getPriorityStep(steps) || getNextStepByOrder(steps, currentStepKind),
    state:
      router.currentAnalyticsProp('page', state) || router.currentName(state),
  };
}

function mapItem(state) {
  return (item) => ({
    kind: item.kind(state),
    status: item.status(state),
  });
}

function mapItemDefinitions(phases, state) {
  return (definition) => ({
    id: definition.id(state),
    code: definition.code(state),
    phaseOrder: (phases[definition.phaseId(state)] || {}).order,
    order: definition.order(state),
    shortDescription: definition.shortDescription(state),
    uiState: definition.uiState(state),
  });
}

function phaseMapReducer(state) {
  return (phases, phase) => ({
    ...phases,
    [phase.id(state)]: {
      name: phase.name(state),
      order: phase.order(state),
    },
  });
}

export function shouldIncludeStep(items, state) {
  return ({ code }) =>
    !(isDeclinedItemType(code, state) || isStatusToSkip(items, code));
}

const SKIP_STATUSES = [ITEM_STATUSES.COMPLETED, ITEM_STATUSES.RESERVED];
function isStatusToSkip(items, code) {
  return items.some(
    ({ kind, status }) => kind === code && SKIP_STATUSES.includes(status)
  );
}

function isDeclinedItemType(code, state) {
  return !!selectors.current.move(state).declinedStatusByCode(code, state);
}
